export default from './takeRight'
